import { useEffect, useState } from "react";
import {useParams, useNavigate } from "react-router-dom";
import Note from "../model/Note";
import NoteForm from "../components/NoteForm";
import { useSelector } from "react-redux";

type Params = {
    noteId: string|undefined;
}

const NoteBlock = () => {
    const navigate = useNavigate();

    const { currentNoteId } = useSelector((state:any) => state.notes);

    const { noteId } = useParams<Params>();    

    const [selectedNoteId, setSelectedNoteId] = useState<string|undefined>(undefined);

    useEffect(() => {
        setSelectedNoteId(currentNoteId);
    }, [currentNoteId])

    useEffect(() => {
        if (noteId) {            
            setSelectedNoteId(noteId);
        }        
    }, [noteId])

    const onSaveNote = (note: Note) => {
        navigate(`/notes/${note.id}`)
    }
    
    return (
         <div className={"page-note "}>
            {!selectedNoteId ? <NoteForm onSave={onSaveNote}/> : <NoteForm noteId={selectedNoteId} onSave={onSaveNote}/>}
        </div>
    )
}

export default NoteBlock;